import React, { useEffect, useState } from "react";
import Image from "../Image/Image";
import UploadButton from "../UploadButton/UploadButton";
import WebcamComponent from "../WebcamComponent/WebcamComponent";
import "./ImagesImportContainer.css";
import { LuCamera, LuScanFace } from "react-icons/lu";
import { useUserStore } from "../../contexts/userStore";
import { base64ToFile } from "../../utils/file";
import { ReaderCaptureModal } from "../ReaderCaptureModal/ReaderCaptureModal";
import { useTranslation } from "react-i18next";

function ImagesImportContainer({ disabled = false, showButtonLabels = true, ...props }) {
	const { t } = useTranslation();
	const [openCamera, setOpenCamera] = useState(false);
	const [showCropper, setShowCropper] = useState(false);
	const [showReaderModal, setShowReaderModal] = useState(false);
	const { selectedCondominioObj } = useUserStore();
	const withReaders = props.withReaders != null ? props.withReaders : true;

	function handleOpenCamera() {
		setOpenCamera(true);
	}

	function handleFileLoaded(file) {
		if (props.onFileChanged) {
			props.onFileChanged(file);
		}
		if (props.setUrlImg) {
			props.setUrlImg(file ? URL.createObjectURL(file) : null);
		}
	}

	async function savePhotoFromCamera(imgSrc) {
		setOpenCamera(false);
		const file = await base64ToFile(imgSrc.replace('data:image/jpeg;base64,', ''), `webcam-photo.jpg`, 'image/jpeg');
		handleFileLoaded(file);
	}

	return (
		<div className="images-import-container">
			<WebcamComponent hidden={!openCamera} submitImg={savePhotoFromCamera} />
			{!openCamera && (
				<React.Fragment>
					<Image
						imgId={props.urlImg}
						alt="profile"
						className="images-import-container-image"
						setUrlImg={props.setUrlImg}
						isPng={false}
						onFileChanged={(file) => {
							handleFileLoaded(file);
						}}
						onShowCropper={setShowCropper}
					/>
					{!showCropper && (
						<div className="images-import-container-buttons">
							<UploadButton
								simple
								onFileChanged={handleFileLoaded}
								showLabel={showButtonLabels}
								label={t("common.import")}
								disabled={disabled}
							/>
							<button
								type="button"
								className="button-white"
								onClick={handleOpenCamera}
								disabled={disabled}
							>
								<LuCamera size={18} />
								{showButtonLabels && t("common.camera")}
							</button>
							{(selectedCondominioObj && withReaders) && (
								<button type="button" className="button-white" disabled={disabled} onClick={() => setShowReaderModal(true)}>
									<LuScanFace size={18} />
									{showButtonLabels && t("common.reader")}
								</button>
							)}
						</div>
					)}
				</React.Fragment>
			)}
			<ReaderCaptureModal
				handleFileLoaded={handleFileLoaded}
				showReaderModal={showReaderModal}
				setShowReaderModal={setShowReaderModal}
				captureOptions={{
					type: 'face',
				}}
			/>
		</div>
	);
}

export default ImagesImportContainer;
